export default __webpack_public_path__ + "static/media/mars.7ab7c2f1.png";